<template>
  <div class="code-task-wrapper">
    <div
      class="modal task code-modal"
      :class="{ 'full-screen': isModalFullScreen }"
      @mouseup="mouseUpAtEditor()"
    >
      <div class="modal-header-actions">
        <div
          v-if="!isMakeCustomTaskComponentOpen"
          class="fullscreen-icon"
          v-b-tooltip.hover.top
          title="Vollbild"
          @click="modalFullScreen()"
        >
          <i v-if="!isModalFullScreen" class="fas fa-expand"></i>
          <i v-else class="fas fa-compress"></i>
        </div>
        <div class="modal-close" @click="close"></div>
      </div>
      <div
        class="round-button item modal-run-action"
        v-if="!isMakeCustomTaskComponentOpen"
        v-b-tooltip.hover.bottom
        title="Ausführen"
        @click="!loading && runCode()"
      >
        <b-spinner v-if="loading" small label="Spinning"></b-spinner>
        <i v-else class="fas fa-play"></i>
      </div>
      <div class="custom-modal-header">
        {{ isMakeCustomTaskComponentOpen ? 'Custom Task' : 'Code ausführen' }}
      </div>
      <div class="content" v-if="isComponentRendered">
        <div class="code-modal-wrapper">
          <div class="header">
            <div class="tools">
              <div
                class="round-button item"
                v-if="!isMakeCustomTaskComponentOpen"
                @click="toggleCredentialModal"
                v-b-tooltip.hover.bottom
                title="Sicher"
              >
                <i class="fa fa-key"></i>
              </div>
              <div
                class="round-button item"
                v-if="!isMakeCustomTaskComponentOpen"
                @click="toggleLogsModal()"
                v-b-tooltip.hover.bottom
                title="Verlauf"
              >
                <img
                  src="../../assets/img/work-flow-icons/log.svg"
                  alt="log"
                  class="log-icon"
                />
              </div>
              <div
                class="round-button item"
                v-if="!isMakeCustomTaskComponentOpen"
                v-b-tooltip.hover.bottom
                @click="downloadFile()"
                title="Herunterladen"
              >
                <i class="fas fa-download"></i>
              </div>
              <div
                class="round-button item"
                v-if="getCodeTaskLength > 5 && !isMakeCustomTaskComponentOpen"
                @click="toggleMakeCustomTaskComponent(true)"
                v-b-tooltip.hover.bottom
                title="In wiederverwendbare Task umwandeln"
              >
                <i class="fa fa-magic"></i>
              </div>
            </div>
          </div>
          <div class="code-tool-wrapper">
            <div class="task-tools"></div>
          </div>
          <div
            class="code-modal-content-wrapper"
            :class="{
              'make-custom-task-model-open': isMakeCustomTaskComponentOpen,
            }"
          >
            <div
              ref="codeContainerRef"
              class="tab"
              v-if="!isMakeCustomTaskComponentOpen"
            >
              <div v-if="loading && isNoteVisible && !hasError" class="notes">
                <p>Wird ausgeführt !</p>
              </div>

              <div class="select-language" v-if="false">
                <select v-model="task.props.language">
                  <option value="py">Python</option>

                  <option value="js">Javascript</option>
                </select>
              </div>
              <div
                class="editor-wrapper dragable-wrapper read-only"
                ref="topTextArea"
                id="codeEditor1"
              >
                <span
                  class="dragable-line-first"
                  @mousedown="mouseDownAtEditor($event, 'codeEditor1')"
                ></span>
                <div class="library-tooltip">
                  <CustomTooltip
                    targetId="description"
                    iconSlotName="icon-slot"
                    toolTipCustomClass="description-tooltip code-task-library-tooltip"
                    placement="bottom"
                  >
                    <template v-slot:icon-slot>
                      <i
                        class="fa fa-question-circle fa-2x icon"
                        id="description"
                      ></i>
                    </template>
                    <template v-slot:tooltip-content>
                      <div class="tooltip_wrapper">
                        <span>Available Libraries:</span>
                        <ul>
                          <li
                            v-for="libraryInfo in availablePythonLibrariesInfo"
                            :key="libraryInfo.name"
                          >
                            <a :href="libraryInfo.docLink" target="_blank"
                              >{{ libraryInfo.name }}-
                              {{ libraryInfo.version }}</a
                            >
                          </li>
                        </ul>
                      </div>
                    </template>
                  </CustomTooltip>
                </div>
                <prism-editor
                  ref="editor-read-only-input"
                  class="code-editor"
                  v-model="inputAsCode"
                  :highlight="highlighter"
                  :readonly="true"
                  line-numbers
                ></prism-editor>
              </div>

              <div
                class="editor-wrapper read-write"
                ref="middleTextArea"
                id="codeEditor2"
              >
                <div
                  class="prompt-modal"
                  :style="{
                    top: promptModal.height + 'px',
                  }"
                  v-if="promptModal.visible"
                  v-click-outside="onPromptModalClickOutside"
                  :class="{ 'is-reversed': promptModal.isReversed }"
                  ref="promptModalRef"
                >
                  <div
                    class="prompt-input-container"
                    v-if="promptModal.visible"
                  >
                    <input
                      type="text"
                      placeholder="write here what the code should do, or choose a prompt"
                      ref="promptInputRef"
                      @keyup="onPromptInputKeyUp"
                    />
                    <button
                      class="get-code-button"
                      @click.stop="getUserPrompt"
                      :disabled="promptModal.isPromptLoading"
                    >
                      get code
                    </button>
                  </div>

                  <div
                    class="prompt-data-container"
                    @click.stop="onPromptDataContainerClick"
                  >
                    <div
                      class="prompt-loader-container"
                      v-if="promptModal.isPromptLoading"
                    >
                      <div class="prompt-loader"></div>
                      <span>fetching data...</span>
                    </div>
                    <div
                      v-if="
                        promptModal.suggestions && !promptModal.isPromptLoading
                      "
                      class="prompt-button-container"
                    >
                      <button
                        v-for="(suggestion, i) in promptModal.suggestions"
                        :key="`${suggestion}_${i}`"
                        v-b-tooltip.hover.bottom
                        :title="suggestion"
                        @click.stop="onSuggestionPromptClick(suggestion, false)"
                      >
                        {{ suggestion }}
                      </button>
                    </div>
                    <i
                      class="fas fa-sync-alt refresh-icon"
                      v-b-tooltip.hover
                      title="refresh suggestions"
                      @click.stop="refreshSuggestions"
                      v-if="
                        promptModal.suggestions && !promptModal.isPromptLoading
                      "
                    ></i>
                  </div>
                </div>
                <prism-editor
                  ref="editor"
                  class="code-editor"
                  v-model="task.props.code"
                  :highlight="highlighter"
                  :readonly="false"
                  line-numbers
                  @input="checkForAiOverlay"
                ></prism-editor>
              </div>
              <div
                ref="bottomTextArea"
                class="editor-wrapper read-only"
                :class="{ 'hide-overflow': loading }"
                id="codeEditor3"
              >
                <span
                  class="dragable-line-second"
                  @mousedown="mouseDownAtEditor($event, 'codeEditor3')"
                ></span>
                <prism-editor
                  ref="editor-read-only-output"
                  class="code-editor"
                  v-model="outputAsCode"
                  :highlight="highlighter"
                  :readonly="true"
                  line-numbers
                ></prism-editor>

                <!-- Use this loading, while run code is running  -->

                <div class="loading" v-show="loading">
                  <div class="progress-icon-wrapper">
                    <div class="progress-icon"></div>
                  </div>
                </div>
              </div>
            </div>
            <MakeCustomTaskComponent
              :flowRunnerEndpoint="flowRunnerEndpoint"
              v-if="isMakeCustomTaskComponentOpen"
              @closeEditModal="toggleMakeCustomTaskComponent(false)"
              :editCodeDetails="task.props"
              :inputFields="task.input"
              :process="process"
              :task="task"
              @showToaster="showToaster"
              @triggerCustomTaskItemFetch="triggerCustomTaskItemFetch"
            />
          </div>
        </div>
      </div>
      <CodeTaskLogsModal
        v-if="isLogModalVisible"
        :processId="process.id"
        :taskId="task.id"
        @onClose="isLogModalVisible = false"
      />
      <CodeCredentialSidebar
        v-if="isCredentialModalVisible"
        :credentialList="credentialList"
        :processId="process.id"
        @close="toggleCredentialModal"
      />

      <!-- Use this loading, while component is rendering  -->

      <div class="loading-container" v-if="!isComponentRendered">
        <LoadingSpinner
          loadingCaption="Wird geladen..."
          v-if="!isComponentRendered"
          class="outer-loader"
        />
      </div>
    </div>
  </div>
</template>

<script>
import codeEditor from '../widgets/codeEditor.vue';
import CustomTooltip from '../CustomTooltip.vue';

// import Prism Editor
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core';

// import syntax highlighting styles
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-python';
import 'prismjs/themes/prism-tomorrow.css';
import MakeCustomTaskComponent from '../widgets/MakeCustomTaskComponent.vue';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import { askChatGPT } from '../../services/workflow.service';
import {
  getApiEndpointVersion,
  getIsVueBasedFormBuilder,
  getFileExtension,
  getFileNameWithoutExtension,
} from '@/utils/helpers';
import CodeCredentialSidebar from '@/components/modals/CodeCredentialSidebar.vue';
import CodeTaskLogsModal from '../modals/CodeTaskLogsModal.vue';
import { getCustomDatabaseItem } from '@/services/customdb.service';
import { getFormElements } from '@/utils/helpers/FormBuilderHelper.js';
import { mapGetters } from 'vuex';
import { getCustomDatabaseItems } from '@/services/axios/data.api';
export default {
  name: 'Code',
  data() {
    return {
      referenceCode: null,
      loading: false,
      isNoteVisible: false,
      hasError: false,
      isComponentRendered: false,
      jsonTypes: ['object', 'objectlist', 'list', 'JSON'],
      modelTypes: [
        'timeseries', // timeseries is needed for backwards compatiblility
        'loadprofile',
        'custom',
        'model',
      ],
      listTypes: ['checkbox'],
      isModalFullScreen: false,
      currentEditor: null,
      m_pos: null,
      isMakeCustomTaskComponentOpen: false,
      isLogModalVisible: false,
      isCredentialModalVisible: false,
      triggerWordRegex: /(?<!')\/\/\//g,
      promptModal: {
        height: 0,
        visible: false,
        isPromptLoading: false,
        suggestions: null,
        language: 'python',
        selectonStart: null,
        isReversed: false,
      },
      credentialList: [],
      availablePythonLibrariesInfo: [
        {
          name: 'pandas',
          docLink: 'https://pandas.pydata.org/docs/',
          version: '2.1.3',
        },

        {
          name: 'matplotlib',
          docLink: 'https://matplotlib.org/stable/users/index',
          version: '3.5.3',
        },
        {
          name: 'boto3',
          docLink:
            'https://boto3.amazonaws.com/v1/documentation/api/latest/index.html',
          version: '1.18.60',
        },

        {
          name: 'numpy',
          docLink: 'https://numpy.org/doc/stable/',
          version: '1.26.2',
        },

        {
          name: 'dynamodb-json',
          docLink: 'https://pypi.org/project/dynamodb-json/',
          version: '1.3',
        },

        {
          name: 'openai',
          docLink:
            'https://platform.openai.com/docs/api-reference/authentication?lang=python',
          version: '1.6.1',
        },
        {
          name: 'openpyxl',
          docLink: 'https://openpyxl.readthedocs.io/en/stable/',
          version: '3.0.10',
        },
        {
          name: 'psycopg2-binary',
          docLink: 'https://www.psycopg.org/docs/install.html',
          version: '2.9.5',
        },
        {
          name: 'requests',
          docLink: 'https://requests.readthedocs.io/en/latest/',
          version: '2.26.0',
        },

        {
          name: 'beautifulsoup4',
          docLink: 'https://beautiful-soup-4.readthedocs.io/en/latest/',
          version: '4.10.0',
        },
        {
          name: 'PyMySQL',
          docLink: 'https://pymysql.readthedocs.io/en/latest/',
          version: '1.0.2',
        },
        {
          name: 'reportlab',
          docLink:
            'https://docs.reportlab.com/install/open_source_installation/',
          version: '3.6.8',
        },
        {
          name: 'xhtml2pdf',
          docLink: 'https://xhtml2pdf.readthedocs.io/en/latest/',
          version: '0.2.6',
        },

        {
          name: 'xlrd',
          docLink: 'https://xlrd.readthedocs.io/en/latest/api.html',
          version: '2.0.1',
        },

        {
          name: 'xlsxwriter',
          docLink: 'https://xlsxwriter.readthedocs.io/',
          version: '3.1.0',
        },
      ],
    };
  },
  props: {
    task: Object,
    process: Object,
    flowRunnerEndpoint: {
      type: String,
    },
    isTableIdArray: { type: Boolean, default: false },
  },
  methods: {
    onPromptDataContainerClick() {
      if (!this.promptModal.suggestions && !this.promptModal.isPromptLoading) {
        this.onPromptModalClickOutside();
      }
    },
    onPromptInputKeyUp(e) {
      if (e && e.key === 'Enter') {
        this.getUserPrompt();
      }
    },
    getUserPrompt() {
      const userPrompt = this.$refs.promptInputRef.value;
      if (userPrompt && userPrompt.trim() !== '') {
        this.onSuggestionPromptClick(userPrompt, true);
      } else {
        this.showToaster(
          'invalid request: please enter a valid request',
          'Fehlerhaft !',
          'danger'
        );
      }
    },
    refreshSuggestions() {
      if (!this.promptModal.isPromptLoading) {
        this.getAiSuggestions();
      }
    },
    resetPromptData() {
      this.promptModal.height = 0;
      this.promptModal.visible = false;
      this.promptModal.selectonStart = null;
      this.promptModal.isReversed = false;
      this.task.props.code = this.getSanitizedCode;
      this.promptModal.isPromptLoading = false;
    },
    onPromptModalClickOutside() {
      if (this.promptModal.visible) {
        this.resetPromptData();
      }
    },
    checkForAiOverlay(value) {
      if (value) {
        const trimmedValue = value.trim();
        if (
          !this.promptModal.visible &&
          trimmedValue.match(this.triggerWordRegex)
        ) {
          if (this.promptModal.suggestions === null) {
            this.getAiSuggestions();
          }
          const editor = this.$refs.editor;

          if (editor) {
            const textarea = editor.$refs.textarea;
            const container = editor.$el;
            const selectionStart = textarea.selectionStart;
            const lineHeight = parseFloat(
              window.getComputedStyle(textarea).lineHeight
            );
            const currentLine = textarea.value
              .substr(0, selectionStart)
              .split('\n').length;
            const isReversed = this.calculateAiOverlayLayout(
              container,
              lineHeight,
              editor,
              currentLine
            );
            const containerRect = container.getBoundingClientRect();
            const cursorHeight = currentLine * lineHeight;
            const finalHeight =
              cursorHeight - (container.scrollTop + 45 + (isReversed ? 45 : 0));
            const overlayBottom = containerRect.height + finalHeight - 24;

            if (overlayBottom > containerRect.bottom - 50 - 10) {
              this.promptModal.height = finalHeight - 20;
            } else {
              const { firstVisibleLine, lastVisibleLine } =
                this.calculateFirstAndLastVisibleEditorLines(
                  container,
                  lineHeight,
                  editor
                );

              this.promptModal.height = [
                firstVisibleLine,
                lastVisibleLine,
              ].includes(currentLine)
                ? firstVisibleLine === currentLine
                  ? finalHeight + 10
                  : finalHeight - 15
                : finalHeight;
            }

            this.promptModal.visible = true;
            this.promptModal.selectonStart = selectionStart;
            setTimeout(() => {
              this.$refs.promptInputRef.focus();
            }, 50);
          }
        }
      }
    },

    calculateFirstAndLastVisibleEditorLines(container, lineHeight, editor) {
      const linesInContainer = Math.floor(container.clientHeight / lineHeight);
      const lastVisibleLine = Math.min(
        editor.lineNumbersCount,
        Math.ceil(container.scrollTop / lineHeight) + linesInContainer
      );
      const firstVisibleLine = Math.ceil(container.scrollTop / lineHeight) + 1;

      return { firstVisibleLine, lastVisibleLine };
    },
    calculateAiOverlayLayout(container, lineHeight, editor, currentLine) {
      const linesInContainer = Math.floor(container.clientHeight / lineHeight);

      const { firstVisibleLine, lastVisibleLine } =
        this.calculateFirstAndLastVisibleEditorLines(
          container,
          lineHeight,
          editor
        );
      const rangeMargin = 3;
      if (
        lastVisibleLine - firstVisibleLine >= linesInContainer - rangeMargin &&
        currentLine >= lastVisibleLine - rangeMargin
      ) {
        this.promptModal.isReversed = true;
        return true;
      }

      return false;
    },
    getSanitizedAIPythonCode(str) {
      const match = str.match(/```python\s*([\s\S]*?)\s*```/i);
      return match ? match[1].trim() : str;
    },
    async onSuggestionPromptClick(suggestion, isUserPrompt) {
      this.promptModal.isPromptLoading = true;
      const sanitizedCode = this.getSanitizedCode;
      const prompt = `you are provided with the "dataInputs" array, the "dataInputs" consists of inputs,you must properly read the provided
      "dataInputs" array ( the name is name of the input , and value is value of the input and the type is the type of input ).
      "dataInputs" array is not accessible in code-editor, it is only for your reference,
      in a code-editor, you have access to these individual inputs from "dataInputs" as "input['inputname'] = inputvalue" variables,
      in code-editor you can use it as "input['inputname']" variable which points to its value ,
      ${
        isUserPrompt
          ? ` Also take reference from the provided "userCode" if the provided "request" has some reference about it. the output code should be in the codeLanguage, if request contains any other language convert that into codeLanguage. `
          : ``
      }
      generate code in the provided "codeLanguage" based on the provided "request" ${
        isUserPrompt ? ` and provided "userCode" ` : ``
      } , only generate code , no explanation needed. if the output-code cannot be generated then give output as 'error'.

      dataInputs: ${this.getInputs},
      codeLanguage: ${this.promptModal.language},
      request: "${suggestion}",
      ${
        isUserPrompt
          ? `userCode: "${
              sanitizedCode && sanitizedCode.trim() ? sanitizedCode.trim() : ``
            }"`
          : ``
      }


      IMPORTANT: return only python code not need of extra comments and strings
      IMPORTANT: if unable to generate code just return reason unable to generate code as python code comment
      IMPORTANT: if user asked you to store anything in resutls then make sure to store it inside the results dictinary(already generared no need to create it again)
      `;

      try {
        const data = await this.fetchChatGPT(prompt);
        if (data && data !== 'error') {
          if (this.promptModal.selectonStart !== null) {
            const code = JSON.parse(JSON.stringify(this.task.props.code));
            const newCode =
              code.substring(0, this.promptModal.selectonStart) +
              data +
              code.substring(this.promptModal.selectonStart);

            this.task.props.code = this.getSanitizedAIPythonCode(newCode);
          } else {
            this.task.props.code += data;
          }

          this.resetPromptData();
        } else {
          this.showToaster(
            'invalid request: code cannot be generated',
            'Fehlerhaft !',
            'danger'
          );
          this.$refs.promptInputRef.value = '';
          this.promptModal.isPromptLoading = false;
        }
      } catch (error) {
        this.showToaster('please try again!', 'Fehlerhaft !', 'danger');
        this.promptModal.isPromptLoading = false;
      }
    },
    async getAiSuggestions() {
      if (this.task.input && this.task.input.length > 0) {
        this.promptModal.isPromptLoading = true;
        const prompt = `in a code-editor, you have access to the input array as variable which you can use in code-editor as input["inputname"],
          you must properly read the provided array ( the name is name of the input , and value is value of the input and the type is the type of input ),
          give text based-suggestions not code, of what you can acheive with the provided information in the code-editor as a person who doesnt know how
          to code and depending on the type on inputs , give no explanation, just an JSON stringified array of direct text based-suggestions and
          importantly the suggestions should not refer to any person , they should be command . also the output should always be in JSON stringified array,
          also the length of the output JSON stringified array should always be equal to provided suggestionArrayLength , not more than that

        inputs: ${this.getInputs},
        suggestionArrayLength: 4`;

        try {
          const data = await this.fetchChatGPT(prompt);

          if (data && JSON.parse(data) && JSON.parse(data.length)) {
            this.promptModal.suggestions = JSON.parse(data);
            this.promptModal.isPromptLoading = false;
          }
        } catch (error) {
          this.showToaster('please try again!', 'Fehlerhaft !', 'danger');
          this.promptModal.isPromptLoading = false;
        }
      }
    },
    async fetchChatGPT(message) {
      try {
        const url = this.flowRunnerEndpoint;
        let response;
        if (getApiEndpointVersion(url) >= 6) {
          const formData = new FormData();
          formData.append(
            'props',
            JSON.stringify({ prompt: message, model: 'gpt-4' })
          );
          response = await askChatGPT(url, formData);
        } else {
          response = await askChatGPT(url, { prompt: message });
        }
        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.message
        ) {
          return response.data.message;
        }
      } catch (error) {
        this.showToaster(error, 'Fehlerhaft !', 'danger');
        this.promptModal.isPromptLoading = false;
        return null;
      }
    },
    close: function () {
      this.task.props.code = this.getSanitizedCode;
      this.$set(this.task, 'output', this.task.output.concat(this.task.input));
      this.$emit('close');
    },
    runCode: function () {
      this.loading = true;
      this.referenceCode = this.task.props.code;

      // As flowrunner expects only first task, remove other tasks
      // and clear output
      const action_data = JSON.parse(JSON.stringify(this.process));

      if (
        action_data.formTrigger != null &&
        action_data.formTrigger.length > 0
      ) {
        action_data.formTrigger.forEach((data) => {
          data.value = data.value.id;
        });
        action_data.tasks.forEach((t) => {
          t.input = [];
          t.output = [];
        });
      }
      let f = JSON.parse(JSON.stringify(action_data));
      if (getApiEndpointVersion(this.flowRunnerEndpoint) > 6) {
        f.tasks = [this.task];
      } else {
        f.tasks = [f.tasks[0]];
      }
      f.tasks[0].output = [];
      // Put props and input in form data
      var formData = new FormData();

      formData.append('flow', JSON.stringify(f));
      formData.append('props', JSON.stringify(this.task.props));
      formData.append('task-id', this.task.id);
      var myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      // Put input in form data
      if (this.task.input) {
        this.task.input.forEach((e) => {
          if (e.type == 'file') formData.append(e.name, e.value);
          else if (this.jsonTypes.includes(e.type))
            formData.append(e.name, JSON.stringify(e.value));
          else if (this.modelTypes.includes(e.type))
            formData.append(e.name, e.value.id);
          else if (this.listTypes.includes(e.type)) {
            e.value.forEach((el) => formData.append(e.name, el));
          } else if (e.type === 'dataframe' || e.type === 'toggleswitch') {
            formData.append(e.name, JSON.stringify(e.value));
          } else formData.append(e.name, e.value);
        });
      }

      // Call API
      var url = this.flowRunnerEndpoint;
      url += '/run_code';

      fetch(url, {
        body: formData,
        headers: myHeaders,
        method: 'post',
      })
        .then(async (response) => {
          if (response.status == 500) {
            let jsn = await response.json().then((jsn) => {
              return jsn;
            });
            throw new Error(jsn['message']);
          }
          if (response.status != 200) throw new Error(response.statusText);
          else return response.json();
        })
        .then((json) => {
          this.task.output = json;

          if (json.filter((e) => e.label == 'error').length > 0) {
            this.hasError = true;
            this.showToaster(
              'Bitte beheben Sie den Fehler im Code !',
              'Fehlerhaft !',
              'danger'
            );
            this.showNote();
            this.$set(this.task, 'status', 'error');
          } else {
            this.hasError = false;
            this.$set(this.task, 'status', 'success');
            this.$emit('resetErrorMessage');
          }

          this.loading = false;
        })
        .catch((e) => {
          this.task.output = [
            {
              label: 'error',
              name: 'error',
              type: 'text',
              value: e,
            },
          ];

          this.hasError = true;
          this.showToaster(
            'Bitte beheben Sie den Fehler im Code !',
            'Fehlerhaft !',
            'danger'
          );
          this.loading = false;
        });
    },
    highlighter(code) {
      return highlight(code, languages.py);
    },
    showNote: function () {
      this.isNoteVisible = true;
      setTimeout(() => {
        this.isNoteVisible = false;
      }, 2000);
    },
    getTSDisplayFormat: function (ts) {
      // Make deepcopy
      let copy = JSON.parse(JSON.stringify(ts));
      // Modify data for display purpose
      if (copy.hasOwnProperty('data')) {
        let d = copy.data.slice(0, 2);
        d.push(['...'], ['...']);
        copy.data = d;
      }

      return copy;
    },
    isObjectTimeseries: function (o) {
      let a = o.hasOwnProperty('ts_type');
      let b = o.hasOwnProperty('supplyPoint');
      let c = o.hasOwnProperty('quantity');
      let d = o.hasOwnProperty('convention');

      return a + b + c + d;
    },
    mouseDownAtEditor(e, editor) {
      e.preventDefault();
      this.currentEditor = editor;
      this.m_pos = e.y;
      document.addEventListener('mousemove', this.resizeCodeEditor, false);
    },
    textAreaHeight() {
      return {
        topPanel: this.$refs.topTextArea.getBoundingClientRect().height,
        middlePanel: this.$refs.middleTextArea.getBoundingClientRect().height,
        bottomPanel: this.$refs.bottomTextArea.getBoundingClientRect().height,
      };
    },
    resizeCodeEditor(e) {
      const panelsHeight = this.textAreaHeight();
      window.addEventListener('mouseup', this.mouseUpAtEditor, true);
      this.m_pos = e.y;

      const codeContainerHeight =
        this.$refs.codeContainerRef.getBoundingClientRect().height;

      const minimumPanelHeight = codeContainerHeight
        ? Math.floor(codeContainerHeight * 0.18)
        : 100;
      //Code for the top code textarea to resize
      if (this.currentEditor === 'codeEditor1') {
        const topPanelNewHeight = panelsHeight.topPanel + e.movementY;
        const middlePanelNewHeight = panelsHeight.middlePanel - e.movementY;
        const bottomPanelNewHeight = panelsHeight.bottomPanel - e.movementY;
        //if condition when middle textarea is bigger than top area
        if (
          topPanelNewHeight > 10 &&
          middlePanelNewHeight > minimumPanelHeight
        ) {
          this.$refs.topTextArea.style.height = topPanelNewHeight + 'px';

          this.$refs.middleTextArea.style.height = middlePanelNewHeight + 'px';
        }

        // if condition when bottom textarea is bigger than top and middel area
        if (
          middlePanelNewHeight < minimumPanelHeight + 5 &&
          bottomPanelNewHeight > minimumPanelHeight
        ) {
          this.$refs.topTextArea.style.height = topPanelNewHeight + 'px';

          this.$refs.bottomTextArea.style.height = bottomPanelNewHeight + 'px';
        }
      }

      //Code for the bottom code textarea to resize
      if (this.currentEditor === 'codeEditor3') {
        const topPanelNewHeight = panelsHeight.topPanel + e.movementY;
        const bottomPanelNewHeight = panelsHeight.bottomPanel - e.movementY;
        const middlePanelNewHeight = panelsHeight.middlePanel + e.movementY;

        //if condition when middle textarea is bigger than bottom area
        if (
          bottomPanelNewHeight > 10 &&
          middlePanelNewHeight > minimumPanelHeight
        ) {
          this.$refs.bottomTextArea.style.height = bottomPanelNewHeight + 'px';

          this.$refs.middleTextArea.style.height = middlePanelNewHeight + 'px';
        }

        //if condition when top textarea is bigger than bottom and middel area
        if (
          topPanelNewHeight > minimumPanelHeight &&
          middlePanelNewHeight < minimumPanelHeight + 5
        ) {
          this.$refs.topTextArea.style.height = topPanelNewHeight + 'px';

          this.$refs.bottomTextArea.style.height = bottomPanelNewHeight + 'px';
        }
      }
    },

    mouseUpAtEditor() {
      //only call removeEventListener for mousemove when mouseup event fire
      document.removeEventListener('mousemove', this.resizeCodeEditor, false);
      window.removeEventListener('mouseup', this.mouseUpAtEditor, true);
    },
    modalFullScreen() {
      this.isModalFullScreen = !this.isModalFullScreen;
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    toggleMakeCustomTaskComponent(value) {
      this.isMakeCustomTaskComponentOpen = value;
    },
    triggerCustomTaskItemFetch(id) {
      this.$emit('tiggerSpecificEvent', { name: 'fetchCustomTaskItem', id });
    },
    toggleLogsModal() {
      this.isLogModalVisible = !this.isLogModalVisible;
    },
    async downloadFile() {
      let inputCode = JSON.parse(JSON.stringify(this.inputAsCode));

      if (this.isAuthentication) {
        const token = this.getAuthToken();
        inputCode = inputCode.replace(token.displayToken, token.authToken);
      }

      const notebook = {
        cells: [
          {
            cell_type: 'code',
            execution_count: null,
            metadata: {},
            outputs: [],
            source: inputCode,
          },
        ],
        metadata: {
          kernel_info: {
            name: 'python',
            display_name: 'Python 3',
          },
          language_info: {
            name: 'python',
            codemirror_mode: {
              name: 'ipython',
              version: 3,
            },
            mimetype: 'text/x-python',
            file_extension: '.py',
          },
        },
        nbformat: 4,
        nbformat_minor: 2,
      };
      const codeCells = this.task.props.code.split('## Cell-Break ##');

      const cellObjects = codeCells.map((codeCell, index) => ({
        cell_type: 'code',
        execution_count: null,
        metadata: {},
        outputs: [],
        source:
          index >= 1
            ? ('## Cell-Break ##' + codeCell).split('\n')
            : codeCell.split('\n'),
      }));

      notebook.cells.push(...cellObjects);

      const notebookContent = JSON.stringify(notebook, null, 4);
      const blob = new Blob([notebookContent], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'notebook.ipynb';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
    getAuthToken() {
      const authToken = localStorage.getItem(
        'CognitoIdentityServiceProvider.61nps3sbkg5vcrn4vl5hduqbf4.' +
          this.user.username +
          '.accessToken'
      );

      return {
        authToken,
        displayToken: authToken.slice(0, 5) + '...',
      };
    },
    getFile: async function (key) {
      let tableName = this.process.tableID;
      if (this.isTableIdArray && this.process.tableID.length > 0) {
        tableName = this.process.tableID[0];
      }
      const findItem = await getCustomDatabaseItem(tableName, key, true);
      return findItem.data;
    },
    toggleCredentialModal() {
      this.isCredentialModalVisible = !this.isCredentialModalVisible;
    },
    async setCustomkeysDatabaseItemList() {
      try {
        if (!this.getCustomKeysDBDetails?.name) return;
        this.isComponentRendered = false;
        const response = await getCustomDatabaseItems(
          this.getCustomKeysDBDetails.name
        );
        if (response?.data?.items?.length)
          this.credentialList = response.data.items;
      } catch (error) {
        console.log('set error', error);
      } finally {
        this.isComponentRendered = true;
      }
    },
  },
  created() {
    this.task.output = [];
    this.setCustomkeysDatabaseItemList();
  },
  computed: {
    ...mapGetters({
      databaseList: 'getDatabaseList',
    }),
    getSanitizedCode() {
      return JSON.parse(JSON.stringify(this.task.props.code)).replaceAll(
        this.triggerWordRegex,
        ''
      );
    },
    getInputs() {
      const inputs = JSON.stringify(
        this.task.input
          .filter((el) => el.name !== 'codelosSettings')
          .map((el) => {
            if (el.type === 'timeseries') {
              return {
                ...el,
                value: { ...el.value, data: el.value.data.slice(0, 5) },
              };
            }
            return el;
          })
      );
      return inputs;
    },
    inputAsCode() {
      let code =
        '""" We initiated this dictionary for you based on the input from the previous task. You can not edit this part of the code, but you can use this dictionary in your code."""\n\n';

      if (this.isComponentRendered) {
        if (this.task.input) {
          this.task.input.forEach((e) => {
            let name = e.name;
            switch (e.type.toLowerCase()) {
              case 'range':
              case 'text':
              case 'email':
              case 'hidden':
              case 'textarea':
              case 'date':
              case 'datetime-local':
              case 'radio':
              case 'toggleswitch':
                if (name != 'codelosSettings')
                  code += 'input["' + name + '"] = "' + e.value + '"\n';
                break;
              case 'formatted_number':
                code += `input["${name}"] = ${
                  e.value === null ? 'None' : e.value
                }\n`;
                break;
              case 'number':
                code += `input["${name}"] = ${
                  e.value === '' ? 'None' : e.value
                }\n`;
                break;
              // Remove timeseries when all flows updated
              // Show only 2 values of data, otherwise building the component takes too long
              case 'timeseries':
              case 'loadprofile':
                code +=
                  'input["' +
                  name +
                  '"] = ' +
                  JSON.stringify(this.getTSDisplayFormat(e.value)) +
                  '\n';
                break;
              case 'objectlist':
              case 'object':
              case 'custom':
              case 'model':
              case 'checkbox':
                code +=
                  'input["' + name + '"] = ' + JSON.stringify(e.value) + '\n';

                break;
              case 'file':
              case 'filenew':
                var fileName;
                if (e?.value?.name) fileName = e.value.name;
                else fileName = e.name;
                code +=
                  'input["' +
                  e.name +
                  '"] = {"file_path": "/{exec_path}/' +
                  fileName +
                  '"}\n';
                break;
              case 'dataframe': {
                // '"] = {"index": [...], "columns": [...],  "data" : [...]'

                const getStrigifyColumns = e.value.columns
                  .slice(0, 3)
                  .map((column) => JSON.stringify(column));

                code +=
                  'input["' +
                  name +
                  '"] = { "index": [' +
                  e.value.index.slice(0, 3) +
                  ',...' +
                  '], "columns": [' +
                  getStrigifyColumns +
                  ',...' +
                  '],  "data" : [...]';
                code += e.value.config ? ', "config": {...} ' : '';

                code += ' }\n';
                break;
              }
              case 'json':
                code +=
                  'input["' +
                  e.label +
                  '"] = ' +
                  JSON.stringify(e.value) +
                  '\n';
                break;
              case 'list':
                code +=
                  'input["' +
                  e.label +
                  '"] = ' +
                  JSON.stringify(e.value) +
                  '\n';
                break;
              case 'select':
                code +=
                  'input["' + e.name + '"] = ' + JSON.stringify(e.value) + '\n';
                break;
            }
          });
        }
        if (this.isAuthentication) {
          code +=
            'input["authorization"] ="' +
            this.getAuthToken().displayToken +
            '"\n';
        }
        // Add extra inputs below
        // Below input is static in front end , it will auto replace in backend
        code += `input["exec_path"] = "/${
          window.location.host.includes('localhost') ? 'run_code_files' : 'tmp'
        }/${new Date().valueOf()}..."\n`;
      }

      return code;
    },
    outputAsCode() {
      let code = '# Results:\n\n';
      this.task.output.forEach((e) => {
        let name = e.name;
        switch (e.type) {
          case 'range':
          case 'text':
          case 'email':
          case 'date':
            if (name != 'codelosSettings')
              code += 'results["' + name + '"] = "' + e.value + '"\n';
            break;
          case 'formatted_number':
          case 'number':
            code += 'results["' + name + '"] = ' + e.value + '\n';
            break;
          case 'file': {
            let path = e.value.file_path;
            const fileName = path?.split('/')[1] || '';
            code +=
              'results["' +
              name +
              '"]' +
              ' = {"file": (' +
              name +
              ', open("' +
              getFileNameWithoutExtension(fileName) +
              '", "rb"), "' +
              getFileExtension(fileName) +
              '")}\n';
            break;
          }
          case 'object':
          case 'list':
            if (this.isObjectTimeseries(e.value)) {
              // Show only 2 values of data, otherwise building the component takes too long
              code +=
                'input["' +
                name +
                '"] = ' +
                JSON.stringify(this.getTSDisplayFormat(e.value)) +
                '\n';
              break;
            } else
              code +=
                'results["' + name + '"] = ' + JSON.stringify(e.value) + '\n';
            break;

          case 'dataframe': {
            const getStrigifyColumns = e.value?.columns
              ?.slice(0, 3)
              ?.map((column) => JSON.stringify(column));

            code +=
              'results["' +
              name +
              '"] = { "index": [' +
              e.value?.index?.slice(0, 3) +
              ',...' +
              '], "columns": [' +
              getStrigifyColumns +
              ',...' +
              '],  "data" : [...]';
            code += e.value?.config ? ', "config": {...} ' : '';

            code += ' }\n';
            break;
          }
          case 'highchart': {
            const valueKeys = Object.keys(e.value);
            code += `results["${name}"] = {`;

            valueKeys.forEach((k, index) => {
              if (Array.isArray(e.value[k])) {
                code += `"${k}" : [...]`;
              } else if (typeof e.value[k] === 'object') {
                code += `"${k}" : {...}`;
              }

              code += valueKeys.length - 1 === index ? '' : ', ';
            });

            code += ' }\n';
            break;
          }
          case 'error':
            code +=
              '# This error occured while executing the code: \n"' +
              e.value +
              '"\n';
            break;
          default:
            break;
        }
      });
      return code;
    },
    user() {
      return this.$store.state.user;
    },
    getCodeTaskLength() {
      return this.task.props.code.replace('Insert your code here', '').length;
    },
    isAuthentication() {
      const startTask = this.process.tasks.find(
        (task) => task.name === 'Start'
      );
      if (startTask) {
        const elements = getFormElements(startTask, this.isVueBasedFormBuilder);
        return (
          elements.filter((e) => e.type == 'html' && e.name == 'authentication')
            .length > 0
        );
      } else return false;
    },
    isVueBasedFormBuilder() {
      return getIsVueBasedFormBuilder(this.process);
    },
    getCustomKeysDBDetails() {
      return this.databaseList.find(
        (database) => database.type == 'custom-keys'
      );
    },
  },
  async mounted() {
    try {
      const customTaskIndex = this.task.input.findIndex(
        (task) => task.name === 'custom'
      );
      if (customTaskIndex !== -1) {
        const item = await this.getFile(
          this.task.input[customTaskIndex].value?.id
        );
        this.task.input[customTaskIndex].value = item;
      }
    } catch (e) {
      const startTaskIndex = this.process.tasks.findIndex(
        (task) => task.name === 'Start'
      );
      if (startTaskIndex === -1) {
        this.$emit('showFileKeySelectModal');
      }
    }
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    PrismEditor,
    // Do not delete codeEditor, its not used but everything will change if we remove it.
    // eslint-disable-next-line vue/no-unused-components
    codeEditor,
    MakeCustomTaskComponent,
    LoadingSpinner,
    CustomTooltip,
    CodeTaskLogsModal,
    CodeCredentialSidebar,
  },
};
</script>

<style scoped>
.code-task-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.code-task-wrapper .modal.task {
  padding-inline: 34px !important;
}
.code-task-wrapper .modal-header-actions {
  position: absolute;
  top: 32px;
  right: 36px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.code-task-wrapper .fullscreen-icon {
  position: static;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 16px;
  color: #000;
  cursor: pointer;
}
.code-task-wrapper .modal-header-actions .modal-close {
  position: static !important;
}
.code-task-wrapper .modal-run-action {
  position: absolute;
  top: 32px;
  left: 36px;
}
.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.code-modal .content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: calc(100% - 36px - 17px);
  margin-top: 17px;
}

.tab {
  text-align: left;
  height: 100%;
}

.tab .notes {
  float: right;
  margin-top: 20px;
}
.tab .notes p {
  color: rgb(247, 57, 89);
  font-size: 13px;
}

/* code-editor */
.dragable-wrapper {
  position: relative;
}
.dragable-line-first {
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 5px;
  background-color: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.5;
  cursor: row-resize;
  z-index: 99;
  user-select: none;
}

.dragable-line-second {
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 5px;
  background-color: #fff;
  opacity: 0.5;
  cursor: row-resize;
  z-index: 9;
}
.editor-wrapper.read-only {
  height: 25%;
}
.tab .editor-wrapper:first-child {
  margin-top: 0;
}
.editor-wrapper {
  margin-top: 25px;
  height: calc(50% - 50px);
  margin-left: auto;
  margin-right: auto;
  overflow-y: hidden;
  width: 100%;
  border-radius: 4px;
}

.editor-wrapper.read-write .prism-editor-wrapper.code-editor {
  height: 100%;
  padding-top: 0;
}
.editor-wrapper.read-write {
  position: relative;
}
::v-deep .prism-editor__container {
  height: fit-content;
  min-height: 450px;
}

.select-language {
  margin-top: 50px;
  width: 100%;
  text-align: right;
}

.select-language select {
  width: 110px;
  height: 42px;
  font-size: 18px;
  border: none;
  background: transparent;
}
.modal.loader {
  overflow: hidden;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

input {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

textarea {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: scroll;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  width: 100%;
}

.imput-group > input {
  width: 70%;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
}

.modal .btn-close {
  margin-left: 14px;
  border: none;
  display: block;
  width: 20px;
  top: 0;
  height: 14px;
  margin-top: 0;
  opacity: 1;
  box-sizing: border-box;
}

button.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  position: relative;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin: 0 18px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .url {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -893px -1109px;
}

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .mscons {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -828px -1175px;
}

.tabsLabels .system {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -137px -1178px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.pull-right.default {
  margin-top: 0;
}

.e-mail-params {
  height: 176px;
}

button {
  margin-top: 20px;
}

.form-group {
  width: 100%;
  height: 50px;
  display: flex;
  margin-top: 0px;
  padding-top: 1px;
  padding-bottom: 1px;
  border-bottom: 1px;
  border-bottom-style: solid;
  border-bottom-color: #dee0e4;
}

.form-group .label {
  margin-top: 20px;
  text-transform: none;
}

.form-group input {
  width: 100%;
  border: 0;
  padding-bottom: 14px;
  padding-top: 18px;
}

input:focus {
  outline: none;
}

.tools {
  left: 594px;
  position: relative;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 46px;
  height: 199px;
}

.element {
  margin-bottom: 16px;
}

.tools .element .button {
  background-color: var(--color-black-lighter);
  fill: #fff;
  stroke: #fff;
  width: 46px;
  height: 46px;
  border-radius: var(--circled);
  border: 0;
  -webkit-box-shadow: var(--elevation-medium);
  box-shadow: var(--elevation-low);
  transform: translateZ(0);
  cursor: pointer;
  outline: 0;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  padding: 0;
  transition: all 0.3s ease-out;
}

.tools .element .button:hover {
  fill: var(--color-black-lighter);
  stroke: var(--color-black-lighter);
  background: #fff;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
}

.task-tools i {
  margin-top: 2px;
  color: black;
}

.pause-code i {
  margin-top: 6px;
  margin-left: 0px;
}

.code-modal-wrapper .left-side-options {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
}

.left-side-options ul {
  display: block;
  list-style-type: none;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

.left-side-options > li {
  display: inline-block;
  margin-right: 10px;
}
.left-side-options > li:last-child {
  margin-right: 0px;
}

.task-tool .left-side-options {
  position: absolute;
  width: auto;
  text-align: right;
}

.task-tool .left-side-options {
  display: block;
  list-style-type: none;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

.left-side-options > li.download .run-code:hover {
  background: rgba(0, 0, 0, 0.03);
  overflow: hidden;
  display: block;
  transition: color 0.15s;
  cursor: pointer;
}

.left-side-options > li.download .run-code {
  box-sizing: border-box;
  border: 1px solid #dbdde0;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  top: 11px;
  left: 11px;
  background: #000;
  overflow: hidden;
  display: block;
  transition: color 0.15s;
}

.left-side-options > li > a,
.left-side-options > span > a {
  border: 1px solid #dbdde0;
  border-radius: 50%;
  height: 42px;
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  color: #000;
  background: #fff;
  transition: color 0.15s;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.13);
}

.accessibility {
  z-index: 30;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 0px !important;
}

.button--loading::after {
  content: '';
  position: absolute;
  width: 35px;
  height: 35px;
  right: 43px;
  bottom: 5px;
  margin: auto;
  border: 2px solid transparent;
  border-top-color: #181818;
  border-radius: 50%;
  animation: button-loading-spinner 1s ease infinite;
}

@keyframes button-loading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}

.paper-clip {
  padding-left: 5px;
  padding-top: 5px;
}

.data-fields {
  margin-top: 10px;
  margin-left: 1px;
}

.action {
  margin-left: -5px;
  margin-top: 24px;
}

:root {
  --color-pink: #f36;
  --color-pink-darker: #e81e61;
  --color-blue-lighter: #f5fbff;
  --color-blue: #276ee5;
  --color-blue-darker: #1f53d5;
  --color-green-lighter: #f2fbfa;
  --color-green: #09baa6;
  --color-green-darker: #00a08e;
  --color-yellow-lighter: #fffbf4;
  --color-yellow: #ffb631;
  --color-yellow-darker: #e8a01e;
  --color-red-lighter: #fdf3f5;
  --color-red: #e01e3d;
  --color-red-darker: #c60d2b;
  --color-ink-lightest: #9599a2;
  --color-ink-lighter: #6e7077;
  --color-ink: #22252b;
  --color-ink-darker: #17191d;
  --color-gray-lightest: #f8f8fa;
  --color-gray-lighter: #ebecee;
  --color-gray: #dee0e4;
  --color-gray-darker: #c7cad1;
  --color-black-lighter: #182237;
  --color-black: #15181f;
  --color-white: #fff;
  --elevation-low: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.12);
  --elevation-medium: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 5px 10px rgba(0, 0, 0, 0.15);
  --elevation-high: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 10px 20px rgba(0, 0, 0, 0.15);
  --rounded: 4px;
  --circled: 50%;
  --pilled: 64px;
}

.tools .element:hover .info-wrapper {
  display: block;
}

.info-wrapper {
  position: absolute;
  display: none;
  will-change: opacity, visibility;
  transition: visibility 0.2s cubic-bezier(0.2, 0.91, 0.85, 0.96) 0.35s,
    opacity 0.2s cubic-bezier(0.2, 0.91, 0.85, 0.96) 0.35s;
  margin-top: -38px;
  right: 59px;
}

.info-wrapper .info {
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  letter-spacing: 0.125px;
  white-space: nowrap;
  color: white;
  background: rgb(23, 25, 29);
  border-radius: 4px;
  padding: 8px 16px;
}

.toggle-list-wrapper {
  background-color: #ffff;
  display: flex;
  position: absolute;
  right: 59px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow-y: scroll;
  z-index: 1;
  margin-top: -93px;
}

.toggle-list-wrapper.data-fields {
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 0px;
  margin-left: -186px;
  overflow-y: scroll;
  max-height: 250px;
}

.toggle-list-wrapper.actions {
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 0px;
  margin-left: -185px;
  overflow-y: scroll;
  max-height: 250px;
}

.toggle-list-wrapper .item {
  height: 135px;
  cursor: pointer;
  border-right: 1px solid #dbdee5;
  padding: 8px;
  width: 130px;
  text-align: center;
}

.toggle-list-wrapper.data-fields .item,
.toggle-list-wrapper.actions .item {
  width: 100%;
  text-align: left;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  font-weight: 300;
  margin: 0;
  padding: 0;
}

.toggle-list-wrapper.data-fields .item:hover,
.toggle-list-wrapper.actions .item:hover {
  background: #f0f0f0;
}

.toggle-list-wrapper.data-fields .item .label,
.toggle-list-wrapper.actions .item .label {
  font-weight: 300;
  color: #464d5d;
  margin: 0;
}

.toggle-list-wrapper .item .label {
  overflow: hidden;
  font-size: 12px;
  text-transform: none;
  padding: 0;
  margin: 0;
  margin-top: 11px;
  height: 44px;
  padding-left: 14px;
  padding-right: 14px;
  color: #596377;
}

.pretty {
  line-height: 36px;
}

.logo {
  width: 35px;
  margin-top: 24px;
}

.check-box {
  border-style: solid;
  height: 16px;
  width: 16px;
  position: relative;
  top: -127px;
  border-width: 1px;
  border-color: var(--color-black);
  left: 1px;
  background-color: #ffff;
  transition: all 0.3s ease-out;
  border-radius: 50%;
}

.check-box .icon {
  fill: #ffff;
  zoom: 0.6;
  padding-top: 6px;
  padding-left: 3px;
}

.item.checked .check-box {
  background-color: var(--color-black);
}

.search {
  width: 200px;
  padding: 11px 0 11px 0;
  height: 21px;
  margin-left: 12px;
  border-bottom: solid 1px #bdc3c7;
  margin-right: 12px;
  margin-bottom: 12px;
}

.search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 23px;
  overflow: hidden;
  display: block;
  width: 24px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
}

.search input {
  border: 0;
  width: fit-content;
  height: 13px;
  cursor: initial;
  padding-top: 11px;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
}

.attachment {
  overflow-y: scroll;
  margin-right: 0;
  display: block;
  width: 300px;
  top: -217px;
  position: relative;
  height: 147px;
  margin-left: 0;
  float: right;
  text-align: right;
  cursor: auto;
}

.attachment .item {
  height: 135px;
  cursor: auto;
  padding: 8px;
  width: 75px;
  text-align: center;
  display: inline-block;
  vertical-align: top;
}

.attachment .item .label {
  font-size: 12px;
  text-transform: none;
  padding: 0;
  margin: 0;
  margin-top: 11px;
  height: 44px;
  color: #596377;
}

.loading {
  width: 100%;
  height: 100%;
  background-color: #2d2d2d;
  position: relative;
  top: -100%;
  z-index: 3;
  opacity: 0.8;
  color: #ffff;
}

.loading.transparent {
  background-color: #9191912e;
}

.progress-icon-wrapper {
  top: 0;
  bottom: 0;
  height: fit-content;
  width: fit-content;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
}

.progress-icon {
  width: 76px;
  height: 76px;
  margin-left: auto;
  top: 0;
  left: 0;
  margin-right: auto;
  margin-top: 0;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #ffff;
  border-color: #ffff transparent #ffff transparent;
  animation: progress-icon 1.2s linear infinite;
}

.loading.full-screen-modal {
  width: 100%;
  height: 100%;
  background-color: #ffff;
  position: initial;
  top: -100%;
  z-index: 3;
  opacity: 1;
}

.loading.transparent.full-screen-modal {
  background-color: #9191912e;
}

.progress-icon-wrapper.full-screen-modal {
  top: 0;
  bottom: 67px;
  height: fit-content;
  width: fit-content;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
  color: rgb(90, 90, 90);
}

.progress-icon.full-screen-modal {
  width: 76px;
  height: 76px;
  margin-left: auto;
  top: 0;
  left: 0;
  margin-right: auto;
  margin-top: 28px;
}

.progress-icon.full-screen-modal:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal.task.full-screen {
  width: 100%;
  height: 100%;
  top: 0;
  box-shadow: none;
  border-radius: 0;
}

.code-modal .modal-options {
  display: flex;
  align-items: center;
  margin-top: 0;
  font-size: 17px;
  color: #000;
}
.code-modal .pull-right i {
  cursor: pointer;
}
#codeEditor1 .prism-editor-wrapper.code-editor {
  padding-top: 0;
}

.code-modal .content .tab {
  display: flex;
  flex-direction: column;
}

div#codeEditor2 {
  flex: 1 1 auto;
}
::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}
.editor-wrapper.hide-overflow {
  overflow-y: hidden;
}

.boostrap-close-btn {
  cursor: pointer;
  display: inline-block;
}
.boostrap-close-btn svg {
  position: relative;
  margin-left: 14px;
}
.listdata {
  display: flex !important;
  flex-direction: column !important;
}

.code-modal .code-modal-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.code-modal .header {
  width: 100%;
  min-height: 70px;
}
.code-modal .header .tools {
  position: static !important;
  top: 0 !important;
  float: right !important;
  height: 70px !important;
  width: auto !important;
  display: flex !important;
  flex-direction: row !important;
  margin-top: 5px;
}
.code-modal .header .tools .item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 61px;
  margin-left: 10px;
}
.code-modal .round-button {
  cursor: pointer;
  display: block;
  color: #1d1d1f;
  border-radius: 50%;
  background-color: #fff;
  height: 60px;
  width: 60px;
  text-align: center;
  line-height: 60px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  transition: transform 0.2s ease-in-out;
  font-size: 17px;
}
.code-modal .header .tools .item:hover {
  transform: scale(1.1) rotate(0);
}
.code-modal .header .tools .item img {
  width: 19px;
  height: 19px;
}

.code-modal .code-modal-wrapper .code-tool-wrapper {
  display: none;
}
.code-modal .task-tools {
  position: relative;
  z-index: 2;
}

.code-modal .code-modal-content-wrapper {
  position: relative;
  z-index: 1;
  height: calc(100% - 42px - 36px);
  margin-top: 36px;
}
.code-modal .code-modal-content-wrapper.make-custom-task-model-open {
  margin-top: 0px;
  height: 100%;
}
.code-modal
  .code-modal-content-wrapper.make-custom-task-model-open
  ::v-deep
  .custom-task-edit-component {
  padding: 0;
}

.code-modal .content .prompt-modal {
  width: 90%;
  position: absolute;
  z-index: 3;
  left: 4%;
  display: flex;
  flex-direction: column;
  min-height: 110px;
  justify-content: flex-end !important;
}

.code-modal .content .prompt-modal.is-reversed {
  flex-direction: column-reverse !important;
}

.code-modal .content .prompt-modal .prompt-button-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
}

.code-modal .content .prompt-modal input {
  background: #2d2d2d;
  border: none;
  margin: 0px;
  height: 40px;
  width: 40%;
  color: white;
}

.code-modal .content .prompt-modal input::placeholder {
  color: rgb(196, 196, 196);
}

.code-modal .content .prompt-modal button {
  width: 240px;
  margin: 0px !important;
  background: #2d2d2d;
  color: white;
  border-radius: 5px;
  white-space: nowrap;
  padding: 10px 30px !important;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
}

.code-modal .content .prompt-modal .prompt-loader-container {
  display: flex;
  align-items: center;
  margin-left: 10px;
  height: 40px;
}

.code-modal .content .prompt-modal .prompt-loader-container span {
  margin-left: 6px;
}

.code-modal .content .prompt-modal .prompt-loader-container .prompt-loader {
  content: ' ';
  display: block;
  width: 20px;
  height: 20px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
}

@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.code-modal .content .prompt-modal .prompt-input-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 79%;
  gap: 15px;
}

.code-modal .content .prompt-modal .prompt-input-container button {
  width: 95px;
  padding: 5px 10px !important;
}

.code-modal .content .prompt-modal .prompt-data-container .refresh-icon {
  font-size: 15px;
  cursor: pointer;
}

.code-modal .content .prompt-modal .prompt-data-container {
  display: flex;
  align-items: center;
  gap: 18px;
  margin: 10px 0px;
  min-height: 40px;
}
.code-modal .library-tooltip {
  position: absolute;
  top: 8px;
  right: 10px;
  z-index: 100;
}
.code-modal .library-tooltip .icon {
  cursor: pointer;
}

@media (min-width: 769px) and (max-width: 1366px) {
  .code-modal .content .prompt-modal button {
    width: 150px;
    font-size: 10px;
    padding: 10px 8px !important;
  }
}

/* tooltip */
.description-tooltip .tooltip-inner {
  background-color: #fff;
  color: #000;
}
.description-tooltip .tooltip-inner ul {
  padding-left: 20px;
  text-align: left;
}
.description-tooltip .tooltip-inner ul li a {
  color: #fff;
}
.description-tooltip .tooltip-inner ul li:hover a {
  color: #008000;
}

.code-task-wrapper .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

.code-task-wrapper .loading-container .loading {
  background-color: #fff !important;
  top: unset !important;
  opacity: 1 !important;
  color: unset !important;
}
.code-task-wrapper .log-icon {
  cursor: pointer;
  width: 18px;
}

.code-task-wrapper .get-code-button:disabled {
  opacity: 0.5;
}
</style>
